import PayProofDialog from './PayProofDialog';
import './style/pay-proof-dialog.less';

export default PayProofDialog;
